(function () {
    if (window.__productGridSilverAOSBound) return;
    window.__productGridSilverAOSBound = true;

    var AOS_CONFIG = { duration: 800, easing: 'ease-in-out', once: true, offset: 100 };
    var RETRY_DELAY = 50;
    var MAX_RETRIES = 40;

    function revealWithoutAOS() {
        document.querySelectorAll('#product-grid-items [data-aos]').forEach(function (element) {
            element.classList.add('aos-init', 'aos-animate');
        });
    }

    function refreshAOS(attempt) {
        if (!window.AOS) {
            if (attempt < MAX_RETRIES) {
                window.setTimeout(function () { refreshAOS(attempt + 1); }, RETRY_DELAY);
                return;
            }
            revealWithoutAOS();
            return;
        }

        if (!window.__aosInited) {
            window.AOS.init(AOS_CONFIG);
            window.__aosInited = true;
        } else if (typeof window.AOS.refreshHard === 'function') {
            window.AOS.refreshHard();
        } else {
            window.AOS.refresh();
        }
    }

    function scheduleAOSRefresh() {
        window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
                refreshAOS(0);
            });
        });
    }

    if (document.readyState !== 'loading') scheduleAOSRefresh();
    else document.addEventListener('DOMContentLoaded', scheduleAOSRefresh);

    window.addEventListener('load', scheduleAOSRefresh);
    window.addEventListener('pageshow', scheduleAOSRefresh);
    document.addEventListener('htmx:afterSwap', scheduleAOSRefresh);
    document.addEventListener('htmx:afterSettle', scheduleAOSRefresh);
    document.addEventListener('htmx:historyRestore', scheduleAOSRefresh);
})();
